import type { CommunityTopic } from '@features/communityContent/topics'
import { createEffect, createSignal } from 'solid-js'

export type GoReadSort = 'latest' | 'discussed'

export interface EditableGoReadPost {
	id: string
	title: string
	topic: CommunityTopic
	content: string
}

const SORT_KEY = 'go_read_sort'
const TOPIC_KEY = 'go_read_topic_filter'

export function useState() {
	const [editPost, setEditPost] = createSignal<EditableGoReadPost | undefined>()
	const [isCreateFormOpen, setIsCreateFormOpen] = createSignal(false)

	const [sort, setSort] = createSignal<GoReadSort>(
		(localStorage.getItem(SORT_KEY) as GoReadSort) || 'latest',
	)
	const [topicFilter, setTopicFilter] = createSignal<CommunityTopic | 'all' | 'mine'>(
		(localStorage.getItem(TOPIC_KEY) as CommunityTopic | 'all' | 'mine') || 'all',
	)
	const [search, setSearch] = createSignal('')

	createEffect(() => localStorage.setItem(SORT_KEY, sort()))
	createEffect(() => localStorage.setItem(TOPIC_KEY, topicFilter()))

	createEffect(() => {
		if (isCreateFormOpen() === false) {
			setEditPost(undefined)
		}
	})

	createEffect(() => {
		if (editPost()) {
			setIsCreateFormOpen(true)
		}
	})

	return {
		editPost,
		setEditPost,
		isCreateFormOpen,
		setIsCreateFormOpen,
		sort,
		setSort,
		topicFilter,
		setTopicFilter,
		search,
		setSearch,
	}
}
